export default "__VITE_ASSET__Cw50JZ3U__"